<div *ngIf="title" class="d-flex justify-content-between align-items-center pb-3 mb-3 chart-header-border">
  <div class="d-flex align-items-center">
    <div class="chart-icon-container me-3">
      <i class="bi bi-pie-chart"></i>
    </div>
    <h3 class="chart-title mb-0">{{ title }}</h3>
  </div>
</div>

<div class="d-flex flex-column card-body p-0">
  <div class="chart-wrapper">
    <div class="chart-container" style="max-height: 80vh">
      <canvas
        style="max-height: 80vh"
        baseChart
        [data]="chartData"
        [options]="chartOptions"
        type="doughnut"
      ></canvas>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-3" *ngIf="totalPages > 1">

    <div class="btn-group mb-2 mb-md-0">
      <button
        class="btn btn-teal-gradient"
        (click)="prevPage()"
        [disabled]="currentPage === 1"
      >
        &larr; Previous
      </button>

      <button
        class="btn btn-teal-gradient"
        (click)="nextPage()"
        [disabled]="currentPage === totalPages || totalPages === 0"
      >
        Next &rarr;
      </button>
    </div>
  </div>
</div>
